<template>
  <b-link :to="'/project/' + content.project_uri">
    <div
      class="card border-0 shadow-sm"
      :class="isTrending ? 'fix-height' : 'h-100'"
      @mouseenter="hoverOn = true"
      @mouseleave="hoverOn = false"
    >
      <div class="custom-overlay">
        <img
          v-if="
            !content.project_thumbnail ||
            content.project_thumbnail.indexOf(' ') !=-1
          "
          :src="
            'https://images.avishkaar.cc/projects-default-thumbnail.webp'
          "
          alt="no-img"
          class="card-img-top"
          height="200px"
        />

        <img
          v-else-if="
            content.project_thumbnail &&
            content.project_thumbnail.includes('https')
          "
          :src="content.project_thumbnail"
          alt="no-img"
          class="card-img-top"
          height="200px"
        />

        <img
          v-else-if="
            content.project_thumbnail &&
            !content.project_thumbnail.includes('https')
          "
          :src="
            'https://avishkaar-users.s3.amazonaws.com/' +
            content.project_thumbnail
          "
          alt="no-img"
          class="card-img-top"
          height="200px"
        />

        <img
          v-else
          :src="
            'https://images.avishkaar.cc/projects-default-thumbnail.webp'
          "
          alt="no-img"
          class="card-img-top"
          height="200px"
        />

        <div class="custom-overlay-items">
          <b-button pill variant="light">View Project</b-button>

          <div class="date">{{ content.creation_date | formatDate }}</div>
        </div>
        <div class="custom-overlay-items-2">
          <div class="ribbon" v-if="false">
            <b-icon icon="trophy" font-scale="1.5" variant="dark"></b-icon>
            <span v-show="hoverOn"> Innovator of the Month </span>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="card-body__title-box">
          <h5 class="title-clamp card-body__title">
            {{ content.project_title }}
          </h5>
          <div class="card-body__views-icon">
            <b-icon icon="eye"></b-icon> {{ content.views }}
          </div>
        </div>
        <p class="card-body__description">{{ content.description }}</p>
      </div>
      <div class="card-footer bg-transparent">
        <router-link class="card-footer__user-avatar" :to="'/user/' + (content.username ? content.username : (content.submittedBy.split(' ')[0]))">
          <b-avatar
            :src="content.profile_img"
            variant="secondary"
            size="2rem"
          ></b-avatar>
        </router-link>
        <router-link class="card-footer__user-name" :to="'/user/' + (content.username ? content.username : (content.submittedBy.split(' ')[0]))">
          Uploaded by
          <strong v-if="content.username">{{ content.username }}</strong>
          <strong v-else>{{ content.submittedBy | firstname }}</strong>
        </router-link>
        <div class="card-footer__skill" v-if="content.skills">
          <div
            class="card-footer__skill-name"
            :style="'border-color:#' + colorChange(content.skills.split(',')[0]) +';color:#' + colorChange(content.skills.split(',')[0])"
            :onchange="getColor(content.skills.split(',')[0])"
          >
            {{ content.skills.split(',')[0] }}
          </div>
        </div>
        <div class="card-footer__skill" v-else-if="content.kitBasedSkill">
          <div
            class="card-footer__skill-name"
            :style="'border-color:#' + colorChange(content.kitBasedSkill) + ';color:#' + colorChange(content.kitBasedSkill)"
            :onchange="getColor(content.kitBasedSkill)"
          >
            {{ content.kitBasedSkill }}
          </div>
        </div>
      </div>
    </div>
  </b-link>
</template>

<script>
import axios from "axios"
const BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "https://localhost:3000";
export default {
  filters: {
    firstname: function (name) {
      if (!name) return "";
      return name.split(" ")[0];
    },
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    isTrending: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      image_url: process.env.VUE_APP_IMAGE_URL,
      hoverOn: false,
      colors: []
    };
  },
  methods: {
    colorChange(param) {
      return this.colors
      .filter((a) => a.skill == param)
      .map((a) => a.color);
      
    },
    getColor(param) {
      axios.get(BASE_URL + "/curriculum/skill/" + param)
        .then(({ data }) => {
          if(this.colors)
          if(this.colors.some(item => item.skill === param)) return;
          this.colors.push({ skill: param,color: data.data.skill_color });
        })
    }
  },
};
</script>

<style lang="scss" scoped>
$border-radius: 10px;
.card {
  margin: 1rem 0.5rem;
  border-radius: 15px;
}
.card-img-top {
  object-fit: cover!important;
}

.card.fix-height {
  height: 400px;
}

.custom-overlay {
  position: relative;
  border-top-left-radius: $border-radius;
  border-top-right-radius: $border-radius;
  & img {
    border-top-left-radius: $border-radius;
    border-top-right-radius: $border-radius;
  }
  & .custom-overlay-items-2 {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    & .ribbon {
      position: absolute;
      left: 0;
      bottom: 0;
      background: #f6d167;
      color: black;
      border-top-right-radius: 50px;
      border-bottom-right-radius: 50px;
      padding: 0.5rem 1rem;
      font-weight: 500;
    }
  }
  & .custom-overlay-items {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.6);
    border-top-left-radius: $border-radius;
    border-top-right-radius: $border-radius;
    & button {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 200px;
      height: 50px;
      transform: translate(-50%, -50%);
      z-index: 2;
    }

    & .date {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0.5rem 1rem;
      font-weight: 500;
      color: white;
    }
  }
}
.card:hover {
  & .custom-overlay {
    & .custom-overlay-items {
      opacity: 1;
    }
  }
}

.card-footer {
  display: flex;
  align-items: center;
  &__user-avatar {
    flex: 0 0 10%;
    margin-right: 0.5rem;
  }

  &__user-name {
    flex: 0 0 50%;
    font-size: 0.9rem;
  }
  &__skill {
    margin-left: auto;
    flex: 0 0 40%;
    text-align: right;
  }
  &__skill-name {
    border-radius: 15px;
    border: 2px solid #9bc157;
    color: #9bc157;
    text-align: center;
    text-transform: uppercase;
    padding: 0.3rem 0.5rem;
    display: inline-block;
    font-size: 0.7rem;
  }
}

.card-body {
  &__title-box {
    display: flex;
  }

  &__title {
    flex: 0 0 70%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-right: auto;
  }

  &__views-icon {
    margin-left: auto;
    flex: 0 0 15%;
    text-align: right;
  }

  &__description {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>